import { ComboboxItem, NativeSelect as MantineSelect, NativeSelectProps } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { forwardRef, Ref } from "react";

import { Label } from "#shared/view/components/Label";

import classes from "./inputs/InputStyles.module.css";

export const NativeSelectInput = forwardRef(
  (
    props: Omit<NativeSelectProps, "data"> & {
      helper?: string;
      withEmptyData?: boolean;
      data: ComboboxItem[];
      size?: "sm" | "md";
    },
    ref: Ref<HTMLSelectElement> | undefined,
  ) => {
    const { label, required, helper, data, withEmptyData, size = "md", ...rest } = props;

    const extendedData = data.map((item) => {
      if (typeof item === "string") {
        return item;
      }

      return {
        value: item.value,
        label: item.label,
      };
    });

    if (withEmptyData) {
      extendedData.unshift({ value: "", label: "" });
    }

    return (
      <MantineSelect
        classNames={{
          input: size === "sm" ? classes.smallInput : classes.input,
        }}
        ref={ref}
        {...rest}
        data={extendedData}
        rightSection={<IconChevronDown size="1rem" />}
        styles={{ section: { pointerEvents: "none" } }}
        required={required}
        withAsterisk={false}
        label={
          label && (
            <Label
              required={required}
              helper={helper}
              classNames={{
                label: size === "sm" ? classes.smallLabel : classes.label,
              }}
            >
              {label}
            </Label>
          )
        }
      />
    );
  },
);
